import {NgSpinningPreloader} from './ng-spinning-preloader.service';

export {
  NgSpinningPreloader
}


// WEBPACK FOOTER //
// C:/Users/micro/Downloads/Proyectos/PagosContabilidadUriel/~/ng2-spinning-preloader/src/index.ts